import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Axios from "axios";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { Grid, Button } from "@material-ui/core";
import { connect } from "react-redux";

import CreateIcon from "@material-ui/icons/Create";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";

import { url } from "../../../config/config";
import Header from "../../../Component/NavBar/User/Header/Header";
import Footer from "../../../Component/NavBar/User/Footer/Footer";
import CustomLoader from "../../../Component/CustomLoader/CustomLoader";

const useStyles = (theme) => ({
  root: {
    padding: 10,
    minHeight: "90vh",
  },
  buttonItem: {
    width: "100%",
    paddingTop: 10,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      alignItems: "center",
    },
  },
  gridContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    paddingTop: 20,
    paddingLeft: 20,
    paddingBottom: 20,
  },
  gridItem: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "row",
    },
  },
  buttonStyle: {
    variant: "outlined",
    backgroundColor: "#d0d84f !important",
    outlineColor: "#d0d84f !important",
    marginBottom: 20,
    [theme.breakpoints.down("sm")]: {
      marginRight: 10,
    },
  },
  bookStyle: {
    backgroundColor: "#f9f9fb",
    cursor: "pointer",
    "&:hover": {
      opacity: 0.6,
    },
  },
  notificationStyle: {
    top: 80,
    right: 10,
  },
});

class SearchResults extends Component {
  constructor(props) {
    super(props);
    this.state = {
      books: [],
      soldBooks: [],
      cartCount: 0,
      isEmpty: true,
      notificationOpen: false,
    };
  }

  componentDidMount() {
    this.getBookData();
    if (this.props.isAuth) {
      this.getCartCount();
      this.getSoldBooks();
    }
  }

  getBookData = async () => {
    const response = await Axios.get(`${url}/api/books`);
    if (response.data.length !== 0) {
      this.setState({
        books: response.data,
        isEmpty: false,
      });
    } else {
      this.setState({
        books: [],
        isEmpty: true,
      });
    }
  };

  getSoldBooks = async () => {
    const response = await Axios.get(`${url}/api/sold/mybooks`, {
      headers: {
        "x-auth-token": this.props.userToken,
      },
    });
    if (response.data.length !== 0) {
      response.data.map((data) =>
        data.itemDetails.map((item) =>
          this.setState({
            soldBooks: [...this.state.soldBooks, { bookId: item.bookId }],
          })
        )
      );
    }
  };

  checkExist = (bookId) => {
    return this.state.soldBooks.findIndex((book) => book.bookId === bookId);
  };

  getCartCount = async () => {
    const response = await Axios.get(`${url}/api/carts/cartDetails`, {
      headers: {
        "x-auth-token": this.props.userToken,
      },
    });
    this.setState({
      cartCount: response.data.cart.length,
    });
  };

  handleCart = async (bookId) => {
    if (this.props.isAuth) {
      const response = await Axios.post(
        `${url}/api/carts/addToCart`,
        { bookId: bookId },
        {
          headers: {
            "x-auth-token": this.props.userToken,
          },
        }
      );
      if (response.data.success) {
        this.setState({
          success: response.data.success,
        });
        this.getCartCount();
        this.handleNotificationOpen();
      }
      if (response.data.bookIncrease) {
        this.getCartCount();
        this.handleNotificationOpen();
      }
    } else {
      this.props.history.push("/login");
    }
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = (notificationStyle) => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        className={notificationStyle}
        autoHideDuration={1600}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="success"
          elevation={6}
          variant="filled"
        >
          Added to cart
        </MuiAlert>
      </SnackBar>
    );
  };

  handleBook = (bookId) => {
    this.props.history.push(`/books/details/${bookId}`);
  };

  compare = (a, b) => {
    const nameA = a.title.toUpperCase();
    const nameB = b.title.toUpperCase();

    let comparison = 0;
    if (nameA > nameB) {
      comparison = 1;
    } else if (nameA < nameB) {
      comparison = -1;
    }
    return comparison;
  };

  render() {
    const { classes } = this.props;
    const filtered = this.state.books.filter((book) => {
      return (
        book.title
          .toLowerCase()
          .indexOf(this.props.match.params.searchResult.toLowerCase()) !== -1
      );
    });
    filtered.sort(this.compare);
    return (
      <div>
        <Header cartCount={this.state.cartCount} />
        <div className={classes.root}>
          <label style={{ fontSize: 30 }}>
            Search Results for {this.props.match.params.searchResult}
          </label>
          {filtered.length !== 0 ? (
            <Grid container spacing={3} className={classes.gridContainer}>
              {filtered.map((book, index) => (
                <Grid item xs sm={3} key={index} className={classes.gridItem}>
                  <div
                    className={classes.bookStyle}
                    onClick={() => this.handleBook(book._id)}
                  >
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <img
                        src={book.bookCoverUrl}
                        alt="BookCoverImage"
                        style={{ width: 200, height: 250 }}
                      />
                    </div>
                    <div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <div style={{ fontSize: 28, fontWeight: "bold" }}>
                          {book.title}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            fontSize: 20,
                          }}
                        >
                          <CreateIcon /> by {book.author.firstName}{" "}
                          {book.author.lastName}
                        </div>
                        <div style={{ fontSize: 18 }}>Price:- {book.price}</div>
                      </div>
                    </div>
                  </div>
                  <div className={classes.buttonItem}>
                    {this.checkExist(book._id) === -1 ? (
                      <Button
                        className={classes.buttonStyle}
                        onClick={() => this.handleCart(book._id)}
                      >
                        <ShoppingCartIcon />
                        <div>Add to Cart</div>
                      </Button>
                    ) : (
                      <Button className={classes.buttonStyle} disabled>
                        Already Bought
                      </Button>
                    )}
                  </div>
                </Grid>
              ))}
              {this.showNotification(classes.notificationStyle)}
            </Grid>
          ) : this.state.isEmpty === false ? (
            <div
              style={{
                marginTop: 50,
                fontSize: 25,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              No Results
            </div>
          ) : (
            <CustomLoader />
          )}
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuth: state.UserReducer.isAuth,
    userToken: state.UserReducer.token,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(SearchResults));
